@let src = this.src();
@let width = this.width();
@let height = this.height();
@let alt = this.alt();

@if (src) {
  <img
    [src]="src"
    [width]="width"
    [height]="height"
    [alt]="alt"
    [style.object-fit]="objectFit()"
    [style.object-position]="objectPosition()"
  />
}
